<template>
  <span class="pointer" v-if="book"
    ><ui-icon
      name="icon-heart"
      :title="$t('favorite')"
      v-if="!isFavorited"
      @click.native="favorite(book)"
      >{{ count }}</ui-icon
    >
    <ui-icon
      name="icon-heart-fill"
      :title="$t('unFavorite')"
      :class="{ 'color-red': isFavorited }"
      v-if="isFavorited"
      @click.native="unFavorite(book)"
      >{{ count }}</ui-icon
    ></span
  >
</template>
<script>
import api from "../api/index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      count: 0,
      isFavorited: false
    };
  },
  props: ["book"],
  computed: {
    ...mapGetters(["authInfo"])
  },
  mounted() {
    this.count = this.book.favoriteList.length;
    let favUsers = this.book.favoriteList.map(o => o["userId"]);
    if (this.authInfo && favUsers.includes(this.authInfo.id)) {
      this.isFavorited = true;
    }
  },
  methods: {
    unFavorite(book) {
      if (!this.authInfo) {
        this.$router.push("/login");
        return;
      }
      api
        .unFavorite({ aid: book.id })
        .then(res => {
          this.isFavorited = false;
          this.count == 0 ? 0 : (this.count -= 1);
        })
        .catch(err => {
          console.log(err);
        });
    },
    favorite(book) {
      if (!this.authInfo) {
        this.$router.push("/login");
        return;
      }
      api
        .addToFavorite({ aid: book.id })
        .then(res => {
          this.isFavorited = true;
          this.count += 1;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
